import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { z } from "zod"
import { useOrganizationQuery, useUpdateOrganizationMutation } from "./service.ts"
import { useEffect } from "react"
import { useProfileQuery } from "../auth/service.ts"

const organizationSchema = z.object({
  name: z.string().min(1, "Название не может быть пустым"),
  description: z.string().optional(),
})

export function OrganizationTab() {
  const { data: profile } = useProfileQuery()
  const { data: organization, isLoading } = useOrganizationQuery(profile?.organization_id, {
    skip: !profile,
  })
  const [updateOrganization] = useUpdateOrganizationMutation()

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm({
    resolver: zodResolver(organizationSchema),
    defaultValues: {
      name: "",
      description: "",
    },
  })

  useEffect(() => {
    if (organization) {
      reset({
        name: organization.name,
        description: organization.description ?? "",
      })
    }
  }, [organization, reset])

  const onSubmit = handleSubmit(async data => {
    if (organization) {
      await updateOrganization({ id: organization.id, ...data })
    }
  })

  if (isLoading) {
    return <div>Загрузка...</div>
  }

  return (
    <form onSubmit={onSubmit}>
      <div className="flex flex-col gap-4">
        <label className="form-control w-full">
          <div className="label">
            <span className="label-text">Название организации</span>
          </div>
          <input
            type="text"
            className={`input input-bordered w-full ${errors.name ? "input-error" : ""}`}
            {...register("name")}
          />
          {errors.name && <span className="text-red-500 text-sm">{errors.name.message}</span>}
        </label>
        <label className="form-control w-full">
          <div className="label">
            <span className="label-text">Описание</span>
          </div>
          <textarea
            className={`textarea textarea-bordered w-full ${errors.description ? "textarea-error" : ""} h-80`}
            {...register("description")}
          />
          {errors.description && <span className="text-red-500 text-sm">{errors.description.message}</span>}
        </label>
      </div>
      <div className="flex justify-end mt-4">
        <button type="submit" className="btn btn-primary" disabled={!isDirty}>
          Сохранить
        </button>
      </div>
    </form>
  )
}
